import { createFileRoute } from "@tanstack/react-router";
import Features from "@/pages/Features";
import { pageHead } from "@/lib/seo";
import { featuresBreadcrumb, featuresFaqSchema } from "@/utils/schema";

export const Route = createFileRoute("/th/features")({
  head: () => ({
    ...pageHead("/features", "th"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(featuresBreadcrumb("th")),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(featuresFaqSchema("th")),
      },
    ],
  }),
  component: Features,
});
